import { render, staticRenderFns } from "./TextEditBox.vue?vue&type=template&id=c4074c9a&scoped=true&"
import script from "./TextEditBox.vue?vue&type=script&lang=ts&"
export * from "./TextEditBox.vue?vue&type=script&lang=ts&"
import style0 from "./TextEditBox.vue?vue&type=style&index=0&id=c4074c9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4074c9a",
  null
  
)

export default component.exports